import React from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  getCookieData,
  DeleteCookieRecord,
} from "../../services/pendingService";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import delete_icon from "../../assets/images/icon/delete.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import { decryptDataFromArray } from "helpers/EncDec";
import { generateMaskedPII, getCompanyTimezoneDateTime } from "helpers/utils";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { useTranslation } from "react-i18next";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";

function CookieList(props) {
  const { t } = useTranslation();
  const [cookieData, setcookieData] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");

  //tabs
  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  useEffect(() => {
    getCookieData()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status) {
          setcookieData(responseData?.data);
        } else {
          toast.error(t(`Cookie List.No Data Available`));
        }
      })
      .catch(err => {
        toast.error(t(`Cookie List.No Data Available`));
      });
  }, []);

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  // Bootstrap table columns
  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let allFranchises = cookieData?.map(el => {
      if (el?.cookie_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setcookieData(allFranchises);
  };

  const columns = [
    {
      dataField: "ip_address",
      text: t(`Cookie List.IP Address`),
      classes: "text-center",
      headerClasses: "text-center",
    },
    {
      dataField: "cookie_type",
      text: t(`Cookie List.Cookies Type`),
      classes: "text-center",
      headerClasses: "text-center",
    },
    {
      dataField: "city",
      text: t(`Cookie List.City`),
      classes: "text-center ",
      headerClasses: "text-center",
    },
    {
      dataField: "state",
      text: t(`Cookie List.State`),
      classes: "text-center",
      headerClasses: "text-center",
    },
    {
      dataField: "browser",
      text: t(`Cookie List.Browser`),
      classes: "text-center",
      headerClasses: "text-center",
    },
    {
      dataField: "email_id",
      text: t(`Cookie List.Email`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: (cell, row) => <>{generateMaskedPII(row?.email_id)}</>,
    },
    {
      dataField: "created",
      text: t(`Cookie List.Created On`),
      classes: "text-center",
      headerClasses: "text-center ",
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format(
          "DD MMM YYYY hh:mm:ss a"
        );
      },
    },
    {
      dataField: "",
      text: t(`Cookie List.Actions`),
      formatter: (cell, row) => {
        let cookie_id = row.id;

        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              <div
                onClick={() => handleCookieRecords(cookie_id)}
                className="text-success blue-icon  blue-color3"
                style={{ cursor: "pointer" }}
                to="#"
                title="Delete"
              >
                <img src={delete_icon} alt="delete_icon" />
                <span>{t(`Cookie List.Delete`)}</span>
              </div>
            </div>
          </div>
        );
      },
    },
    // Add more columns as needed
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Cookie List.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };
  // Delete Faqs
  const handleCookieRecords = franchise_id => {
    DeleteCookieRecord(franchise_id)
      .then(res => {
        if (res.status == 200) {
          let messages = toast.success(
            t(`Cookie List.Record deleted successfully`)
          );
          window.location.reload();
        } else {
          toast.error(res?.data?.message);
          ref.current?.scrollIntoView({ behavior: "smooth" });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  //rohit-code//
  const renderCheck = item => {
    let searchableText = JSON.stringify(item)?.toLowerCase();
    if (searchableText?.includes(query?.toLowerCase())) {
      return true;
    }
    return false;
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  return (
    <>
      <div className="page-content departmentpage pb-1">
        <div className="joblist-container create-vacancy">
          <Row className="mb-1 align-items-center">
            <Col lg="6" md="6" className="Joblist-column">
              <Link to="/dashboard">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  Cookies List
                </h5>
              </Link>
            </Col>
          </Row>
        </div>

        {/* <div className="outerTab-box-wrapper below-vacancy amsterresign  applicationcard-table pt-2"> */}
        <div className="outerTab-box-wrapper applicationcard-table">
          <div className="franchise-list-page">
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                // aria-labelledby="pills-home-tab"
              >
                <div className="tabel-franchise table-responsive">
                  <div className="tabel-application table-responsive">
                    <div className="table-data-search">
                      <div className="total-record">
                        <h5>
                          {t(`Cookie List.Total Records`)}:{" "}
                          <span>{cookieData?.length || 0}</span>
                        </h5>
                      </div>
                      <div className="total-serachbar cookieslist">
                        <div className="serach-bar-top">
                          <form className="form-inline">
                            <input
                              className="form-control mr-sm-2"
                              type="search"
                              placeholder={t(`Cookie List.Search By`)}
                              aria-label="Search"
                              onChange={e => setQuery(e.target.value)}
                              title={`Please enter ${t(
                                `Cookie List.Search By`
                              ).toLowerCase()}`}
                            />
                            <span>
                              <img src={serach_icon} alt="search" />
                            </span>
                          </form>
                        </div>

                        <div className="tale-text right-panel">
                          <button
                            className="button left"
                            onClick={() => handleScroll("left")}
                            data-tooltip={t(`Cookie List.Scroll Left`)}
                          >
                            <img src={right_arrow} alt="right-arrow" />
                          </button>
                          <button
                            className="button right"
                            onClick={() => handleScroll("right")}
                            data-tooltip={t(`Cookie List.Scroll Right`)}
                          >
                            <img src={right_arrow} alt="right-arrow" />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="tabel-application table-responsive white-space-row  pb-3">
                      <div className="timeto-hire-card userlist pendiglist-cardss">
                        <div className="table-custome-class range-custome">
                          <div className="scroll-container">
                            <div className="table-pending-list">
                              <div
                                className="table-wrapper"
                                ref={tableWrapperRef}
                              >
                                <BootstrapTable
                                  keyField="id"
                                  data={cookieData?.filter(renderCheck)}
                                  columns={columns}
                                  pagination={paginationFactory(options)}
                                  rowClasses={rowClasses}
                                  hover
                                  responsive
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CookieList;
